
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

/**
 * Components
 *
 */
const components = {
}

/**
 * Static Data
 *
 */
const filterDateFrom = moment().format(`DD/MM/YYYY`)
const filterDateTo = moment().format(`DD/MM/YYYY`)
const data = function () {
  return {
    current_item_id: null,
    filter_datefrom: filterDateFrom,
    filter_dateto: filterDateTo,
  }
}

/**
 * Computed
 *
 */
const computed = mapGetters({
  listOriginal: `Product/ExpenditureReportPayment/list`,
  meta: `Product/ExpenditureReportPayment/listMeta`,
})

computed.list = function () {
  const group = []
  let currentGroup = null
  let currentGroupID = null
  let total_amount = 0

  this.listOriginal.forEach((item) => {
    if (!currentGroupID) {
      currentGroupID = item.method_id
      currentGroup = []
    } else if (currentGroupID !== item.method_id) {
      group.push({ list: currentGroup, total_amount })

      currentGroupID = item.method_id
      currentGroup = []
      total_amount = 0
    }

    currentGroup.push(item)
    total_amount += item.amount
  })

  group.push({ list: currentGroup, total_amount })

  return group
}

computed.totalExpend = function () {
  return this.list.reduce((total, group) => {
    total += group.total_amount
    return total
  }, 0)
}

/**
 * Methods
 *
 */
const methods = mapActions({
  setListOption: `Product/ExpenditureReportPayment/setListOption`,
  reload: `Product/ExpenditureReportPayment/fetchList`,
  pagePrev: `Product/ExpenditureReportPayment/pagePrev`,
  pageNext: `Product/ExpenditureReportPayment/pageNext`,
})

methods.showopt = function () {
  this.$refs.TableOptionsDialog.show()
}

methods.search = function (value) {
  this.setListOption({ search: value })
}

/**
 * Watch
 *
 */
const watch = {
  meta: {
    deep: true,
    handler(n, o) {
      n.version !== o.version && this.reload()
    },
  },
  filter_datefrom: {
    handler(value) {
      this.setListOption({ datefrom: value })
    }
  },
  filter_dateto: {
    handler(value) {
      this.setListOption({ dateto: value })
    }
  },
}

/**
 * Event OnMounted
 *
 */
const mounted = async function() {
}

/**
 * Event OnCreated
 *
 */
const created = async function() {
  if (this.meta.filter.format !== `deep`) {
    this.setListOption({ format: `deep` })
  }

  this.setListOption({ datefrom: this.filter_datefrom, dateto: this.filter_dateto })
}

/**
 * Event Socket
 *
 */
const sockets = {
}

export default {
  components,
  data,
  computed,
  methods,
  watch,
  mounted,
  created,
  sockets,
}
</script>

<style scoped>
  .bg-green {
    background-color: #80ef7324;
  }
  .bg-orange {
    background-color: #f1bd6e40;
  }
</style>

<template>
  <Row>

    <Col12>
      <table class="no-style">
        <tr>
          <td width="140"></td>
          <td width="10"></td>
          <td></td>
        </tr>
        <tr>
          <td><label>PERIODE</label></td>
          <td><label>:</label></td>
          <td>
            <ul class="list-inline-style">
              <li><SelectDateChangable v-model="filter_datefrom"></SelectDateChangable></li>
              <li>-</li>
              <li><SelectDateChangable v-model="filter_dateto"></SelectDateChangable></li>
            </ul>
          </td>
        </tr>
        <tr>
          <td><label>TOTAL PEMBAYARAN</label></td>
          <td><label>:</label></td>
          <td>{{ totalExpend.toLocaleString() }}</td>
        </tr>
      </table>
    </Col12>

    <Col12>
      <br>
    </Col12>

    <TableList v-for="(groupitem, groupindex) in list" :key="groupindex">
      <template #head>
        <th width="40" class="text-center">#</th>
        <th width="200" class="text-left">Metode Pembayaran</th>
        <th width="120" class="text-left">Tanggal Bayar</th>
        <th width="180" class="text-left">Record / Tanggal Order</th>
        <th width="140" class="text-left">Supplier</th>
        <th width="100" class="text-right">Jumlah</th>
        <th class="text-left">Approval Code</th>
      </template>

      <template #body>
        <tr v-for="(item, index) in groupitem.list" :key="item.id">
          <td class="text-center" v-html="index + meta.curstart"></td>
          <td class="text-left">{{ item.method_name }}</td>
          <td class="text-left">{{ item.date_readable }}</td>
          <td class="text-left">
            <router-link class="link underlined" :to="`/rep/sales-transaction/${item.parent_id}`">
              {{ item.parent_record_id }}
            </router-link>
            <p class="subdata">{{ item.parent_date_ordered_readable }}</p>
          </td>
          <td class="text-left">{{ item.supplier_name }}</td>
          <td class="text-right">{{ item.amount_readable }}</td>
          <td class="text-left">{{ item.approval_code }}</td>
        </tr>
        <tr class="custom-bg-primary-light">
          <td class="text-left"></td>
          <td class="text-left"><label>Total</label></td>
          <td class="text-right"></td>
          <td class="text-right"></td>
          <td class="text-right"></td>
          <td class="text-right">{{ groupitem.total_amount.toLocaleString() }}</td>
          <td class="text-right"></td>
        </tr>
      </template>
    </TableList>
  </Row>
</template>